/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Text, TextArea, Button, Card, Heading } from "@radix-ui/themes";
import { GeneralContextFunc } from "../Context/GeneralContex";
import { updateNotes } from "../Services/DashboardApi";
import { useLocation, useNavigate } from "react-router-dom";

const NotesBox = ({ notes, getCampaignDataById }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setloader, initAlert } = GeneralContextFunc();
  const [Notes, setNotes] = useState("");
  
  useEffect(() => {
    setNotes(notes);
  }, [notes]);

  const saveBtn = () => {
    setloader(true);

    let payload = {
      id: location.state.id,
      Notes: Notes,
    };
    updateNotes(payload)
      .then((res) => {
        initAlert(res?.message);
        let payload = {
          id: location.state.id,
        };
        getCampaignDataById(payload);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-8">
      {/* Header Section */}
      <div className="mb-8">
        <Heading size="6" className="text-gray-900 font-semibold mb-2">
          Campaign Notes
        </Heading>
        <Text size="3" className="text-gray-600">
          Add and manage notes for this campaign
        </Text>
      </div>

      {/* Notes Section */}
      <Card className="p-6 bg-white shadow-sm border border-gray-200">
        <div className="flex items-center mb-6">
          <div className="w-1 h-8 bg-yellow-500 rounded-full mr-4"></div>
          <Heading size="4" className="text-gray-900 font-semibold">
            Campaign Notes
          </Heading>
        </div>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Text size="2" className="text-gray-700 font-medium">
              Notes
            </Text>
            <TextArea
              value={Notes}
              onChange={(e) => setNotes(e.target.value)}
              variant="soft"
              size="3"
              className="min-h-[200px] w-full"
              placeholder="Add your notes about this campaign..."
            />
          </div>
        </div>
      </Card>

      {/* Save Button */}
      <div className="flex justify-end pt-6">
        <Button 
          size="3" 
          onClick={() => saveBtn()} 
          className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors shadow-sm"
        >
          Save Notes
        </Button>
      </div>
    </div>
  );
};

export default NotesBox;
